import { GetOneParams, GetOneResult } from "react-admin";
import { AbstractDataProvider } from "./AbstractDataProvider";
import { instructorsProvider } from "./instructorsProvider";
import { studentsProvider } from "./studentsProvider";
import { baseUrl as serverBaseUrl, serverAPI, type UserDto } from "../api/server.api";

export interface User {
  id: string;
  name: string;
  isAutovioStaff?: boolean;
  avatarUrl?: string;
}

class UsersProvider extends AbstractDataProvider<User> {
  private _getUserPromisesCache = new Map<string, Promise<UserDto>>();

  async getOne(_resource: string, { id }: GetOneParams): Promise<GetOneResult<User>> {
    if (id === "backend") {
      return { data: { id, name: "AUTOVIO" } };
    }
    const cachedUser = instructorsProvider.getOneFromCache(id) || studentsProvider.getOneFromCache(id);
    if (cachedUser) {
      return { data: { id, name: cachedUser.name, avatarUrl: cachedUser.avatarUrl } };
    }
    const cachedPromise = this._getUserPromisesCache.get(id);
    if (cachedPromise) {
      return { data: _userDtoToUser(id, await cachedPromise) };
    }
    const getUserPromise = serverAPI.getUser(id);
    this._getUserPromisesCache.set(id, getUserPromise);
    try {
      return { data: _userDtoToUser(id, await getUserPromise) };
    } catch (error) {
      this._getUserPromisesCache.delete(id);
      throw error;
    }
  }

  getAvatarUrl(userId: string): string {
    if (userId === "backend") {
      return "/AUTOVIO_logo.png";
    }
    return `${serverBaseUrl}/user/${userId}/avatar`;
  }
}

function _userDtoToUser(id: string, userDto: UserDto): User {
  return {
    id,
    name: `${userDto.firstName} ${userDto.lastName}`.trim(),
    isAutovioStaff: userDto.isAutovioStaff,
    avatarUrl: usersProvider.getAvatarUrl(id),
  };
}

export const usersProvider = new UsersProvider();
